module.exports = __webpack_public_path__ + "gn.svg?0798100ed78e72cc9070bb01924cba7e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/gn.svg
// module id = 1126
// module chunks = 0